import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';

export default function PassportErrorBoundary({ children }) {
  const { pathname } = useLocation();
  const componentName = `Passport route: ${pathname}`;

  return (
    <ErrorBoundary key={pathname} componentName={componentName}>
      {children}
    </ErrorBoundary>
  );
}
